import React from 'react'
import { useLocation, Link } from 'react-router-dom';

const LinkContainer = ({Icon, title, to}) => {
  const { pathname } = useLocation();

  return (
    <>
        <Link to={to} className={`rounded-full text-white ${pathname === to ? "bg-primary":"hover:bg-primary"}    transition-all  mb-2 group flex space-x-3 py-3 px-4 items-center justify-start`}>
            <Icon className={`transition-all flex-shrink-0  ${pathname === to ? "text-white":"text-gray-500"} group-hover:text-white text-xl  `} />
            <span className={`transition-all text-sm font-medium  group-hover:text-white  ${pathname === to ? "text-white font-semibold" : "text-gray-500"}`}>
              {
                title
              }
            </span>
      </Link>
    </>
  )
}

export default LinkContainer